import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useIntake } from "./useIntake";
import { SourceTabs, DefaultRelationship, UploadSource, PasteSource, WebsiteSource, AnalyzeButton } from "./IntakeSources";
import { IntakeReview } from "./IntakeReview";

/* Shared by the GUI modal (mode="commit") and onboarding (mode="stage"). */
export const IntakePanel = ({ userId, instanceId, mode = "commit", initialItems, seedCustomers, onStage, onCommitted, footer }) => {
  const k = useIntake({ userId, instanceId, mode, initialItems, seedCustomers, onStage, onCommitted });
  const needsInput = k.tab === "upload" ? !k.files.length : k.tab === "paste" ? !k.text.trim() : true;

  return (
    <div className="space-y-4" data-testid="intake-panel">
      <SourceTabs tab={k.tab} setTab={k.setTab} webCount={k.webItems.length} />
      {k.tab === "upload" && <UploadSource files={k.files} addFiles={k.addFiles} removeFile={k.removeFile} />}
      {k.tab === "paste" && <PasteSource text={k.text} setText={k.setText} />}
      {k.tab === "website" && <WebsiteSource key={k.webItems.length} webItems={k.webItems} onAdd={k.addWebsiteItems} mode={mode} />}
      {k.tab !== "website" && (
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <DefaultRelationship value={k.defaultRel} onChange={k.setDefaultRel} />
          <AnalyzeButton busy={k.busy} stage={k.stage} onClick={k.analyze} disabled={needsInput} />
        </div>
      )}
      <IntakeReview items={k.items} setRelationship={k.setRelationship} setAllRelationship={k.setAllRelationship} removeItem={k.removeItem} clear={k.clear} />
      {mode === "commit" && k.items.length > 0 && (
        <div className="flex justify-end">
          <Button onClick={k.commit} disabled={k.busy} className="bg-emerald-500 hover:bg-emerald-500/90 text-black font-medium rounded-xl" data-testid="intake-commit-btn">
            {k.busy && k.stage === "Saving" ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />} Save {k.items.length} to my CRM
          </Button>
        </div>
      )}
      {footer?.(k)}
    </div>
  );
};

export const IntakeModal = ({ open, onClose, userId, instanceId, onCommitted }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-3xl bg-[#0f1419] border-white/10 text-white max-h-[90vh] overflow-y-auto" data-testid="intake-modal">
      <DialogHeader>
        <DialogTitle className="text-xl font-light">Add customers &amp; prospects</DialogTitle>
        <DialogDescription className="text-gray-400">Current customers sharpen targeting and farming; wishlist targets go straight into the hunt. Nothing is saved until you confirm.</DialogDescription>
      </DialogHeader>
      <IntakePanel userId={userId} instanceId={instanceId} mode="commit" onCommitted={(res) => { onCommitted?.(res); onClose(); }} />
    </DialogContent>
  </Dialog>
);
